import { Checkbox } from "@components/ui/checkbox";
import { Label } from "@components/ui/label";
import { SingleValueFilterOption } from "@lib/utils/types/filters";
import { OnSelect } from "@lib/utils/types/filters/OnSelect";
import { useTransition } from "react";

interface IMultiSelect {
  values: SingleValueFilterOption[];
  onSelect: (value: OnSelect) => void;
  selectedValues: string[];
}

export function MultiSelect({
  values,
  onSelect,
  selectedValues,
}: IMultiSelect) {
  const [_, startTransition] = useTransition();
  return (
    <div className="flex flex-col space-y-5">
      {values.map(({ id, value, name, label }) => (
        <div className="flex items-center space-x-2" key={id}>
          <Checkbox
            id={id}
            checked={selectedValues.indexOf(value) > -1}
            onCheckedChange={() =>
              startTransition(() => {
                onSelect({
                  type: "multiple",
                  name: name,
                  value: value,
                });
              })
            }
          />
          <Label htmlFor={id}>{label}</Label>
        </div>
      ))}
    </div>
  );
}
